import {observe} from '@github/selector-observer'
import poof from '@github-ui/confetti'

observe('.js-confetti-party', () => {
  poof()
})
